import { render, staticRenderFns } from "./addPower.vue?vue&type=template&id=a93247c0&scoped=true&"
import script from "./addPower.vue?vue&type=script&lang=js&"
export * from "./addPower.vue?vue&type=script&lang=js&"
import style0 from "./addPower.vue?vue&type=style&index=0&id=a93247c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93247c0",
  null
  
)

export default component.exports